import { createContext, PropsWithChildren, useState } from "react";

type TableView = "list" | "grid";

export interface ITableViewContext {
  view: TableView;
  setView: (v: TableView) => void;
}

export const TableViewContext = createContext<ITableViewContext | null>(null);

export function TableViewProvider({ children }: PropsWithChildren) {
  const [view, setView] = useState<TableView>("list");
  return (
    <TableViewContext.Provider value={{ view, setView }}>
      {children}
    </TableViewContext.Provider>
  );
}
